import { useQuery } from '@apollo/client';
import { theme } from 'aimo-ui';
import InfoBox from 'components/common/InfoBox';
import Icon from 'components/icons/Icon';
import { GET_PARKING_ZONE_LANES } from 'graphql/queries/readParkingZoneLanes';
import { t } from 'i18next';
import React, { useEffect } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { useParkingStore } from 'stores/parkingStore';
import styled from 'styled-components/native';
import { useUiStore } from 'stores/uiStore';

const DisplayStartButton = ({
  parkingZoneUid,
}: {
  parkingZoneUid?: string;
}) => {
  const TextContainer = styled.Text`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme: appTheme }) => appTheme.colors.black};
    flex-shrink: 1;
  `;

  const { data } = useQuery(GET_PARKING_ZONE_LANES, {
    variables: { parkingZoneUid },
    skip: !parkingZoneUid,
  });

  useEffect(() => {
    useParkingStore.getState().setAnprParkingInput(data?.readParkingZoneLanes);
  }, [data?.readParkingZoneLanes]);

  const handleStartAnprParking = async () => {
    useUiStore.getState().setSheetModal('OpenBarrierManually');
  };

  return (
    <View style={{ marginTop: 10 }}>
      <TouchableOpacity onPress={handleStartAnprParking}>
        <InfoBox
          padding={15}
          margin={10}
          bgColor={theme.colors.lightBg.green}
          leftComponent={<Icon name="Bulb" size="xl" />}>
          <TextContainer>{t('parking.manualANPRMessage')}</TextContainer>
        </InfoBox>
      </TouchableOpacity>
    </View>
  );
};

export default DisplayStartButton;
